import React from 'react';

import EditColumnsButton from '../../../../components/edit-columns-button';
import { EditInventoryColumnsModalContainer } from '../../../../containers/edit-inventory-columns-modal-container';
import { useModal } from '../../../../hooks/use-modal';

const EditProductsInventoryGridColumnsButton = () => {
  const { close, isOpen, open } = useModal();

  return (
    <React.Fragment>
      <EditColumnsButton onClick={open} />
      {isOpen && <EditInventoryColumnsModalContainer onClose={close} />}
    </React.Fragment>
  );
};

export default EditProductsInventoryGridColumnsButton;
